// src/Reducers/AddEditDeviceReducer.js
import {
  DEVICE_TYPES_LOADING,
  DEVICE_TYPES_SUCCESS,
  DEVICE_TYPES_ERROR,
  DEVICE_STATUS_LOADING,
  DEVICE_STATUS_SUCCESS,
  DEVICE_STATUS_ERROR,
  DEVICE_ADD_LOADING,
  DEVICE_ADD_SUCCESS,
  DEVICE_ADD_ERROR,
  DEVICE_UPDATE_LOADING,
  DEVICE_UPDATE_SUCCESS,
  DEVICE_UPDATE_ERROR,
  DEVICE_TRIGGERS_LOADING,
  DEVICE_TRIGGERS_SUCCESS,
  DEVICE_TRIGGERS_ERROR,
  RESET_DEVICE_STATE,
  UPLOAD_LIST_LOADING,
  UPLOAD_LIST_SUCCESS,
  UPLOAD_LIST_ERROR,
  RESET_UPLOAD_LIST,
  DEVICE_DUPLICATE_ERROR,
  UPLOAD_LIST_ERROR_FILE,
  DEVICE_TRIGGERS_PBC_ERROR,
  DEVICE_TRIGGERS_PBC_SUCCESS,
  DEVICE_TRIGGERS_PBC_LOADING,
   DEVICE_TRIGGERS_PB_ERROR,
  DEVICE_TRIGGERS_PB_SUCCESS,
  DEVICE_TRIGGERS_PB_LOADING
} from '../Actions/AddEditDeviceAction';

const initialState = {
  deviceTypes: {
    loading: false,
    data: [],
    error: null
  },
  statusTypes: {
    loading: false,
    data: [],
    error: null
  },
  addDevice: {
    loading: false,
    data: null,
    error: null,
    isSuccess: false,
    duplicateError:null,
  },
   duplicatErr: {
    loading: false,
    data: null,
    error: null,
    isSuccess: false,
    duplicateError:null,
  },
  updateDevice: {
    loading: false,
    data: null,
    error: null,
    isSuccess: false
  },
  triggerOptions: {
    loading: false,
    data: [],
    error: null
  },
    triggerOptionsPBC: {
    loading: false,
    data: [],
    error: null
  },
   triggerOptionsPB: {
    loading: false,
    data: [],
    error: null
  },
  bulkupload: {
    loading: false,
    success: false,
    error: null,
  },
  errorSheet:{
    errorFile: [],
     error: null,
    isSuccess: false
  },
  dowbloadBlueprintSuccess: false,

};

const addEditDeviceReducer = (state = initialState, action) => {
  switch (action.type) {
    // Device Types
    case DEVICE_TYPES_LOADING:
      return {
        ...state,
        deviceTypes: {
          ...state.deviceTypes,
          loading: true,
          error: null
        }
      };
    case DEVICE_TYPES_SUCCESS:
      return {
        ...state,
        deviceTypes: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    case DEVICE_TYPES_ERROR:
      return {
        ...state,
        deviceTypes: {
          ...state.deviceTypes,
          loading: false,
          error: action.payload
        }
      };

    // Status Types
    case DEVICE_STATUS_LOADING:
      return {
        ...state,
        statusTypes: {
          ...state.statusTypes,
          loading: true,
          error: null
        }
      };
    case DEVICE_STATUS_SUCCESS:
      return {
        ...state,
        statusTypes: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    case DEVICE_STATUS_ERROR:
      return {
        ...state,
        statusTypes: {
          ...state.statusTypes,
          loading: false,
          error: action.payload
        }
      };

    // Add Device
    case DEVICE_ADD_LOADING:
      return {
        ...state,
        addDevice: {
          ...state.addDevice,
          loading: true,
          error: null,
          isSuccess: false,
          duplicateError:null
        }
      };
    case DEVICE_ADD_SUCCESS:
      return {
        ...state,
        addDevice: {
          loading: false,
          data: action.payload,
          error: null,
          isSuccess: true,
           duplicateError:null
        }
      };
    case DEVICE_ADD_ERROR:
      return {
        ...state,
        addDevice: {
          ...state.addDevice,
          loading: false,
          error: action.payload,
          isSuccess: false,
           duplicateError:null
        }
      };
 case DEVICE_DUPLICATE_ERROR:
    return {
      ...state,
      duplicatErr: {
        ...state.duplicatErr,
        loading: false,
        error: null,
        isSuccess: false,
        duplicateError:action.payload,
      }
    };
    case "DEVICE_DUPLICATE_RESET":
    return {
      ...state,
      duplicatErr: {
        ...state.duplicatErr,
        duplicateError:null,
      },
    };
    // Update Device
    case DEVICE_UPDATE_LOADING:
      return {
        ...state,
        updateDevice: {
          ...state.updateDevice,
          loading: true,
          error: null,
          isSuccess: false
        }
      };
    case DEVICE_UPDATE_SUCCESS:
      return {
        ...state,
        updateDevice: {
          loading: false,
          data: action.payload,
          error: null,
          isSuccess: true
        }
      };
    case DEVICE_UPDATE_ERROR:
      return {
        ...state,
        updateDevice: {
          ...state.updateDevice,
          loading: false,
          error: action.payload,
          isSuccess: false
        }
      };

    // Trigger Options
    case DEVICE_TRIGGERS_LOADING:
      return {
        ...state,
        triggerOptions: {
          ...state.triggerOptions,
          loading: true,
          error: null
        }
      };
    case DEVICE_TRIGGERS_SUCCESS:
      return {
        ...state,
        triggerOptions: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    case DEVICE_TRIGGERS_ERROR:
      return {
        ...state,
        triggerOptions: {
          ...state.triggerOptions,
          loading: false,
          error: action.payload
        }
      };
     case DEVICE_TRIGGERS_PBC_LOADING:
      return {
        ...state,
        triggerOptionsPBC: {
          ...state.triggerOptionsPBC,
          loading: true,
          error: null
        }
      };
    case DEVICE_TRIGGERS_PBC_SUCCESS:
      return {
        ...state,
        triggerOptionsPBC: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    case DEVICE_TRIGGERS_PBC_ERROR:
      return {
        ...state,
        triggerOptionsPBC: {
          ...state.triggerOptionsPBC,
          loading: false,
          error: action.payload
        }
      };
      case DEVICE_TRIGGERS_PB_LOADING:
      return {
        ...state,
        triggerOptionsPB: {
          ...state.triggerOptionsPB,
          loading: true,
          error: null
        }
      };
    case DEVICE_TRIGGERS_PB_SUCCESS:
      return {
        ...state,
        triggerOptionsPB: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    case DEVICE_TRIGGERS_PB_ERROR:
      return {
        ...state,
        triggerOptionsPB: {
          ...state.triggerOptionsPB,
          loading: false,
          error: action.payload
        }
      };
    // Reset Device State
    case RESET_DEVICE_STATE:
      return {
        ...state,
        addDevice: {
          loading: false,
          data: null,
          error: null,
          isSuccess: false
        },
        updateDevice: {
          loading: false,
          data: null,
          error: null,
          isSuccess: false
        }
      };
    case UPLOAD_LIST_LOADING:
      return {
        ...state,
        bulkupload: {
          loading: false,
          success: false,
          error: null,
        }
      }
    case UPLOAD_LIST_SUCCESS:
      return {
        ...state,
        bulkupload: {
          loading: false,
          success: true,
          error: null,
        }
      }
    case UPLOAD_LIST_ERROR:
      return {
        ...state,
        bulkupload: {
          loading: false,
          success: false,
          error: action.payload,
        }
      }
    case UPLOAD_LIST_ERROR_FILE:
      return {
        ...state,
        errorSheet: {
          errorFile: action.payload,
          error: null,
          isSuccess: false,
        }
      }
    case "DOWNLOAD_BLUEPRINT_SUCCESS": 
      return {
        ...state,
        dowbloadBlueprintSuccess: true,
      }
    case "RESET_DOWNLOAD_BLUEPRINT_SUCCESS":
      return {
        ...state,
        dowbloadBlueprintSuccess: false,
      }
    case RESET_UPLOAD_LIST:
      return {
        ...state,
        bulkupload: {
          loading: false,
          success: false,
          error: null,
        }
      }

    
    default:
      return state;
  }
};

export default addEditDeviceReducer;